module.exports = __webpack_public_path__ + "media/images/weather/63_night-13e9c2baf09d61956f0f3944884fb4e8.png";